import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import "../../pages/buynowaddress/buynowaddress.css";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import Subscribe from "../../components/subscribe/Subscribe";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { baseURL } from "../../constants/url";
import OrderSummaryCartDetails from "../../components/orderSummaryDetails/OrderSummaryCartDetails";
import Swal from "sweetalert2";

const BuyNowCartAddress = () => {
  const { state } = useLocation();
  const cartItems = state?.cartItems || [];

  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  // Fees
  const platformFee = 8;
  const deliveryCharge = 49;

  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(`${baseURL}common/addresses/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAddresses(res.data);
    } catch (error) {
      Swal.fire("Error", "Failed to load addresses!", "error");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this address?")) return;

    setDeletingId(id);

    try {
      const token = localStorage.getItem("authToken");
      await axios.delete(`${baseURL}common/addresses/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire("Success", "Address deleted successfully!", "success");

      if (selectedAddressId === id) {
        setSelectedAddressId(null);
        setShowOrderSummary(false);
      }

      fetchAddresses();
    } catch (error) {
      Swal.fire("Error", "Error deleting address", "error");
    } finally {
      setDeletingId(null);
    }
  };

  const handleDeliveryHere = (addressId) => {
    setSelectedAddressId(addressId);
    setShowOrderSummary(true);
  };

  //  Calculate cart total
  const calculateTotal = () => {
    return cartItems.reduce(
      (total, item) =>
        total + Number(item.final_price || 0) * Number(item.quantity || 0),
      0
    );
  };

  //  Final total including fees
  const calculateFinalTotal = () => {
    return calculateTotal() + platformFee + deliveryCharge;
  };

  return (
    <>
      <Header />

      <div className="container mt_30">
        <div className="row">
          {/* ADDRESS SECTION */}
          <div className="col-lg-8">
            <h4>Select Delivery Address</h4>

            {addresses.length === 0 ? (
              <>
                <p>No addresses found.</p>
                <Link to="/profile" className="common_btn_all">
                  <AddIcon /> ADD ADDRESS
                </Link>
              </>
            ) : (
              addresses.map((addr) => (
                <div
                  key={addr.id}
                  className={`address_set mt_20 padd_10 border_gray ${
                    selectedAddressId === addr.id ? "selected" : ""
                  }`}
                >
                  <div className="d_flex gap_15">
                    <input
                      type="radio"
                      name="selectedAddress"
                      value={addr.id}
                      checked={selectedAddressId === addr.id}
                      onChange={() => {
                        setSelectedAddressId(addr.id);
                        setShowOrderSummary(false);
                      }}
                    />

                    <div className="widthFull">
                      <div className="d_flex align_center justify_sp_between">
                        <span className="text_capitalize address-type">{addr.address_type}</span>

                        <button
                          className="cross_btn" style={{ marginTop: "0px" }}
                          onClick={() => handleDelete(addr.id)}
                        >
                          {deletingId === addr.id ? (
                            "Removing..."
                          ) : (
                            <DeleteIcon />
                          )}
                        </button>
                      </div>

                      <h6>
                        {addr.name} - {addr.phone_number}
                      </h6>

                      <p>
                        {addr.area}, {addr.locality}, {addr.city},{" "}
                        {addr.state} - {addr.pincode}
                      </p>

                      {selectedAddressId === addr.id && (
                        <button
                          className="add-cart-btn mt_10"
                          onClick={() => handleDeliveryHere(addr.id)}
                        >
                          Deliver Here
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}

            {showOrderSummary && (
              <div className="mt_30">
                <OrderSummaryCartDetails
                  selectedAddressId={selectedAddressId}
                  cartItems={cartItems}
                  platformFee={platformFee}
                  deliveryCharge={deliveryCharge}
                />
              </div>
            )}
          </div>

          {/* PRICE DETAILS */}
          <div className="col-lg-4 pt_25">
            <div className="card_common2 mt_20">
              <div className="border_bottom pl_30 pr_30 pt_20">
                <h6>Price Details</h6>
              </div>

              <div className="pl_30 pr_30 pt_10">
                <h6>Items in Cart</h6>

                {cartItems.map((item, index) => (
                  <div key={index} className="pb_10 border_bottom_dash">
                    <p>
                      <strong>{item.product_name}</strong>
                    </p>
                    <p>
                      Qty: {item.quantity} × ₹{item.final_price} = ₹
                      {(item.final_price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                ))}
              </div>

              <div className="pl_30 pr_30 pt_20 pb_30">
                <div className="d_flex justify_sp_between pb_10">
                  <p>Total Price</p>
                  <p>₹{calculateTotal().toFixed(2)}</p>
                </div>

                <div className="d_flex justify_sp_between pb_10">
                  <p>Platform Fee</p>
                  <p>₹{platformFee}</p>
                </div>

                <div className="d_flex justify_sp_between pb_10">
                  <p>Delivery Charge</p>
                  <p>₹{deliveryCharge}</p>
                </div>

                <div className="d_flex justify_sp_between pt_10 pb_10 border_top_dash">
                  <p className="font_bold">Total Amount</p>
                  <p className="font_bold">
                    ₹{calculateFinalTotal().toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Subscribe />
      <Footer />
    </>
  );
};

export default BuyNowCartAddress;
